import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Briefcase, BarChart3, FileText, ShieldCheck, Heart, Layers } from "lucide-react";
import { Button } from "../components/ui/button";

const points = [
  { icon: <Briefcase className="w-5 h-5" />, t: "Workforce performance audit", b: "Pinpoint stress, recovery and energy gaps before they affect output." },
  { icon: <BarChart3 className="w-5 h-5" />, t: "Enterprise reporting", b: "Aggregated, anonymised dashboards for HR, People & Wellbeing leads." },
  { icon: <FileText className="w-5 h-5" />, t: "Board-ready exports", b: "One-click 7/14/30-day PDF and CSV reports." },
  { icon: <Heart className="w-5 h-5" />, t: "Voluntary opt-in outreach", b: "Only contact employees who explicitly request support." },
  { icon: <ShieldCheck className="w-5 h-5" />, t: "GDPR-aligned by design", b: "Medical disclaimer gating, lawful basis, data minimisation." },
  { icon: <Layers className="w-5 h-5" />, t: "Departmental Health Benchmarking", b: "Compare cohorts and surface where stress, sleep or recovery is leaking team output." },
];

export default function ForBusinesses() {
  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20" data-testid="for-businesses-page">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }} className="max-w-3xl">
        <span className="eyebrow">For Businesses</span>
        <h1 className="font-display tracking-tighter text-5xl sm:text-6xl mt-4 leading-[1.05]">
          Quantify the wellness of your workforce.
        </h1>
        <p className="text-lg text-slate-300 mt-6 leading-relaxed">
          Fitest gives People &amp; Wellbeing leaders an evidence base for every wellness investment.
          Run audits, get tiered insights, and act on what actually moves the needle.
        </p>
        <div className="mt-8 flex gap-3 flex-wrap">
          <Link to="/request-demo">
            <Button className="btn-glow rounded-full h-12 px-7" data-testid="biz-cta-demo">Request Demo</Button>
          </Link>
          <Link to="/pricing">
            <Button className="btn-ghost-bordered rounded-full h-12 px-7" data-testid="biz-cta-pricing">Business Licence</Button>
          </Link>
        </div>
      </motion.div>

      <div className="mt-20 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {points.map((p, idx) => (
          <div key={p.t} className="glass rounded-2xl p-6" data-testid={`biz-point-${idx}`}>
            <div className="w-10 h-10 grid place-items-center rounded-lg bg-white/5 border border-white/10 text-brand mb-5">
              {p.icon}
            </div>
            <h3 className="font-display text-lg mb-2">{p.t}</h3>
            <p className="text-sm text-slate-400 leading-relaxed">{p.b}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
